export default __webpack_public_path__ + "static/media/fedex.7c19a30b.svg";